<template>
  <div
    class="game-body"
    v-if="loadedPage"
    :style="cssProps">
    <div class="game-desktop-background"></div>
    <div v-if="step != 'finished'" class="game-content-background"></div>
    <div v-if="game.background_stripes" class="game-desktop-background-stripes"></div>
    <!--<span
      v-if="isDevelopment"
      class="dev-navigation">
      DEV
      <router-link class="btn" :to="{ name: 'SpinOnboarding' }">onboarding</router-link>
    </span>-->

    <div
      v-if="step == 'finished'"
      class="game-page-absolute">
      <div v-html="game.winner_text"></div>
      <div class="btn btn-activate"
        @click="ctaDoneRedirect()">
        {{ game.cta_done_button || transl.Games.back }}
      </div>
    </div>
    <div
      v-else
      class="game-page">
      <div
        v-if="step == 'tiebreaker'"
        class="tiebreaker-container">
        <div class="image-container">
          <div
            v-if="game.terms_text"
            class="info-icon-bottom-right"
            @click="tocModal = true"
            style="cursor: pointer;" >
            <iconComponent
              class="game-info-icon"
              symbol="info"
              width="18px"/>
          </div>
          <img class="tiebreaker-image" v-if="game.tiebreak_image" :src="game.tiebreak_image.url" alt="">
        </div>

        <div class="tiebreaker-question">
          <div class="tiebreaker-text" v-html="game.tiebreak_text"></div>
          <Form
            :questions="[game.tiebreak_question]"
            :accentColor="game.accent_color"
            :textColor="game.text_color"
            :submitButton="game.tiebreak_button_text"
            @answeredAll="tiebreakAnswer = $event"
            @missingRequired="tiebreakAnswer = ''"
            @submit="participate()"/>

          <div class="winner-info" v-html="game.winner_text"></div>
        </div>
      </div>

      <div
        v-else-if="step == 'spin'"
        class="spin-container">
        <div class="image-container">
          <div
            v-if="game.terms_text"
            class="info-icon-bottom-right"
            @click="tocModal = true"
            style="cursor: pointer;" >
            <iconComponent
              class="game-info-icon"
              symbol="info"
              width="18px"/>
          </div>
          <img class="tiebreaker-image" v-if="game.hunt_image" :src="game.hunt_image.url" alt="">
          <div
            v-if="haveClaims"
            class="shop-header-claims clickable"
            @click="claimsModal = true">
            <iconComponent symbol="gift" :width="25" :fill="game.accent_color"/>
          </div>
        </div>

        <div class="spin-content">
          <div class="hunt-header">
            <h2>{{ game.hunt_header }}</h2>
          </div>
  
          <!--WHEEL-->
          <div
            v-if="game.wheel_image"  
            class="spinner-background">
            <div class="spinner-wrapper">
              <md-icon class="md-size-3x">keyboard_arrow_down</md-icon>
              <div
                class="spinner"
                ref="spinner"
                unselectable="on"
                onselectstart="return false;"
                onmousedown="return false;"
                :style="{
                  transform: `rotate(${-currentAngle}deg)`,
                  transition: `transform ${this.spinTime}s ease`,
                }">
                <img :src="game.wheel_image.url" alt="">
              </div>
            </div>
          </div>
  
          <button
            class="btn btn-activate btn-fit"
            :disabled="!spinAgain"
            @click="spinTheWheel()">Random spin</button>
  
          <div
            class="bottom-content text-align-center"
            style="margin: 0 16px;">
            <h3>{{ game.hunt_funfacts_header }}</h3>
            <div v-html="game.hunt_funfacts[randomIndex]"></div>
          </div>
        </div>
      </div>

      <div
        v-else-if="step == 'address'"
        class="survey-wrapper">
        <Form
          class="pv-form"
          :questions="addressForm"
          :answers="addressData"
          :accentColor="game.accent_color"
          :textColor="game.text_color"
          :submitButton="transl.Games.submit"
          @answeredAll="addressData = $event"
          @missingRequired="addressData = {}"
          @submit="setAddress()"/>
      </div>

      <div
        v-else-if="step == 'survey'"
        class="survey-wrapper">

      <!-- Trigger snackbar when finished ? and send email to participation -->
        <img v-if="game.tiebreak_image" :src="game.tiebreak_image.url" alt="">
        <div class="survey-container">
          <div class="points-grid" v-if="participation && participation.points">
            <span class="scan-text">{{ game.hunt_header }}</span>
          </div>

          <div class="survey-header">{{ game.survey_header }}</div>
          <Form
            class="survey-all-questions"
            :questions="game.survey"
            :accentColor="game.accent_color"
            :textColor="game.text_color"
            :submitButton="transl.Games.submit"
            @answeredAll="surveyAnswers = $event"
            @missingRequired="surveyAnswers = {}"
            @submit="setSurvey()"/>
        </div>
      </div>
    </div>

    <modal v-if="tocModal" @close="tocModal = false" size="medium" padding="0" :terms="true">
      <slot>
        <div class="terms-wrapper">
          <div v-html="game.terms_text" class="html-text"></div>
        </div>
        <div class="terms-buttons">
          <div
            v-if="authenticated && game.terms_merchandise && !participation.accepted_merchandise && !hasAcceptedGame"
            class="terms-merchandise-grid">
            <inputField
              v-model="acceptMerchandise"
              inputType="checkbox"/>
            <span
              class="terms-merchandise-text"
              v-html="game.terms_merchandise"></span>
          </div>

          <div v-if="authenticated && !hasAcceptedGame" class="btn btn-activate" @click="acceptGameTerms()">
            {{ transl.UserPV.accept }}
          </div>

          <div class="btn btn-secondary" @click="tocModal = false">
            {{ transl.UserPV.close }}
          </div>
        </div>
      </slot>
    </modal>

    <modal v-if="spinMessageModal" @close="spinMessageModal = false" size="medium">
      <slot>
        <div class="spin-message-wrapper">
          <div class="spin-message-text" v-html="spinMessage"></div>
          <div class="btn btn-activate" @click="spinMessageModal = false">
            {{ transl.UserPV.close }}
          </div>
        </div>
      </slot>
    </modal>

    <modal
      v-if="claimsModal"
      @close="claimsModal = false" size="medium">
      <slot>
        <div class="claims-wrapper">
          <div class="claims-header" v-html="game.claims_description"></div>
          <div class="claims">
            <div
              v-for="claim in participation.claims"
              :key="claim._id"
              class="claim">
              <div
                v-if="claim.media?.url"
                class="claim--image"
                :style="`background-image: url(${claim.media.url})`" alt=""></div>
              <div class="claim--name"><b>{{ claim.name || claim.prize_type }}</b></div>
              <div class="claim--tracking">{{ claim.delivery_tracking }}</div>
            </div>
          </div>
        </div>

        <div class="btn btn-secondary" @click="claimsModal = false">
          {{ transl.UserPV.close }}
        </div>
      </slot>
    </modal>

    <canvas
      v-if="showConfetti"
      ref="confettiCanvas"
      class="confetti-canvas"
      style="position:fixed;left:0;top:0;width:100vw;height:100vh;pointer-events:none;z-index:9999;">
    </canvas>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep as _cloneDeep } from 'lodash-es';
import confetti from 'canvas-confetti';
import BeforeEnterMixin from '../../mixins/BeforeEnterMixin';
import EntityMixin from '../../mixins/EntityMixin';
import GameMixin from '../../mixins/GameMixin';
import InputField from '../../stories/components/InputField/InputField';
import Form from '../../stories/components/Form/Form';

export default {
  name: 'SpinHome',
  components: {
    InputField,
    Form,
  },
  props: ['gameId'],
  mixins: [BeforeEnterMixin, EntityMixin, GameMixin],
  data() {
    return {
      gameType: 'Spin',
      step: 'spin',
      angle: 0,
      spinTime: 3, // 3 is a good number for production
      spinAgain: true,
      showConfetti: false,
      confettiTime: 3,
    };
  },
  async mounted() {
    const success = await this.getGame();
    if (!success) {
      return;
    }
  },
  watch: {
    claimsModal(newVal) {
      if (newVal) {
        this.launchConfetti();
      } else {
        this.showConfetti = false;
      }
    },
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'user',
      'participation',
      'canAddParticipation',
      'reason',
    ]),
    currentAngle() {
      let currentAngle = 0;
      if (this.angle) {
        currentAngle = this.angle;
      } else if (this.participation?.attempts?.length) {
        const attempts = this.participation.attempts.length;
        currentAngle = this.participation.attempts[attempts-1].angle;
      }
      return currentAngle;
    },
    canSpin() {
      return this.hasCurrentParticipation
        && this.participation?.attempts?.length >= this.game.wheel_spins + this.participation.attempts_additional;
    },
    canSpinAgain() {
      return this.canSpin
      && (this.haveClaims && this.game.can_win_multiple_times) || (!this.haveClaims);
    },
  },
  methods: {
    setStep() {
      const game = this.game;
      const participation = this.participation;
      if (!this.authenticated && game.must_login) {
        this.gotoOnboarding();
      } else if (!this.hasCurrentParticipation && !game.tiebreak) {
        this.gotoOnboarding();
      } else if (!this.hasCurrentParticipation && !this.canAddParticipation) {
        this.gotoError();
      } else if (!this.hasCurrentParticipation && game.tiebreak) {
        this.step = 'tiebreaker';
        if (game.terms_must_accept && !this.hasAcceptedGame) {
          this.tocModal = true;
        }
      } else if (this.haveClaims && game.survey?.length && !participation.survey_answers?.length) {
        this.step = 'survey';
      } else if (this.haveClaims && game.winner_address && !participation.address) {
        this.setAddressData();
        this.step = 'address';
      } else if (!game.can_win_multiple_times && this.haveClaims) {
        this.step = 'finished';
      } else {
        this.step = 'spin';
      }
      this.loadedPage = true;
    },
    gotoError() {
      console.log('Home gotoError');
      this.$router.push({ name: 'SpinError' });
    },
    gotoOnboarding() {
      console.log('Home gotoOnboarding');
      const query = this.$route.query;
      this.$router.push({ name: 'SpinOnboarding', query });
    },
    async spinTheWheel() {
      this.spinAgain = false;
      const {
        success, prize, prizeIndex, finalAngle, message,
      } = await this.$store.dispatch('spinTheWheel', this.attach({}));
      if (!success) {
        // take me to error page?
        this.setAlert(message);
        this.spinAgain = true;
        return;
      }

      this.angle = finalAngle;
      this.prize = prize;

      if (prize._id) {
        this.launchConfetti();
      }

      setTimeout(() => {
        this.spinAgain = true;
        this.showSpinMessage(prizeIndex);
      }, 1000 * this.spinTime);
    },
    showSpinMessage(prizeIndex) {
      this.spinMessage = this.game.wheel_areas[prizeIndex].message;
      this.spinMessageModal = true;
    },
    launchConfetti() {
      this.showConfetti = true;
      this.$nextTick(() => {
        const canvas = this.$refs.confettiCanvas;
        if (canvas) {
          confetti.create(canvas, { resize: true })({
            particleCount: 150,
            spread: 70,
            origin: { y: 0.6 },
            // colors: ['#ff0000', '#00ff00', '#0000ff']
          });
          // Optionally, hide the canvas after a short delay
          setTimeout(() => {
            this.showConfetti = false;
          }, 1000 * this.confettiTime);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/games/Spin/Base";
@import "../../assets/scss/games/Spin/Home";
</style>
